import React from "react";
import "./style.css";

const HelpSection = () => {
  return (
    <div className="help-center-wrapper">
      <h1>
        Coming Soon<span className="help-center-dot">.</span>
      </h1>
      <p>Your go-to place for support and guidance. Stay tuned for updates!</p>
      {/* <div className="help-center-icons">
        <a href="#"><i className="fa fa-twitter"></i></a>
        <a href="#"><i className="fa fa-youtube-play"></i></a>
        <a href="#"><i className="fa fa-paper-plane"></i></a>
      </div> */}
    </div>
  );
};

export default HelpSection;
